import {mapState, mapGetters, mapActions} from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
	...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])


export const simpleComputed = {
  ...mapState('simple', {
    simple: (state) => state.simple,
  }),
	...mapGetters('simple', ['isShowingProgress', 'messages', 'player', 'isWideMode']),

}

export const simpleMethods = {
	...mapActions('simple', [
			'showProgress', 'hideProgress',
		'pushMessage', 'deleteMessage',
		'playerOpen', 'playerHide', 'playerPlay',
		'setWideMode'
	])
}
